module.exports = __webpack_public_path__ + "static/media/equal-salary-banner.ccdf9cba.jpg";